
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { enCurrency } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';

export class CurrencyService {

  private currency$ = new ReplaySubject<enCurrency>(1);

  constructor() {
    this.currency$.next(enCurrency.BRL);
  }

  public setCurrency(currency: enCurrency) {
    this.currency$.next(currency);
  }

  public getCurrency(): Observable<enCurrency> {
    return this.currency$
      .asObservable()
      .distinctUntilChanged();
  }

}

// tslint:disable-next-line:variable-name
export const CurrencyServiceFactory = () => new CurrencyService();

export const currencyService = CurrencyServiceFactory();


// WEBPACK FOOTER //
// ./src/services/CurrencyService.ts